import type { UserDetails } from "@app/interfaces/UserDetails";
import { API } from "./BaseAPI";

export async function GetCapsuleUser() {
	const res = await API().get<{ user: UserDetails }>("users/current");
	return res.data.user;
}

export async function Logout() {
	await API().post("auth/logout/");
	window.location.href = "/auth/login";
}
